import React, {Component, Fragment} from "react"
import {_get} from "../Api";
import ModalDelete from "../Components/Modals"
import Loader from "../Components/Loader";
import {Button} from "reactstrap";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faPlus,
    faPencilAlt,
    faSortAmountUp,
    faSortAmountDown,
    faSort,
    faWindowClose,
    faFileCsv, faFileImport
} from '@fortawesome/free-solid-svg-icons'

import {imgPath, exportCsvPath} from "../Helpers";
import {Link} from "react-router-dom";


class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            _last_action_time: Date.now(),
            _blink: {},
            checkbox_all: false,
            delete_multiple: false,
            pagination: false,
            itemsPerPage: false,
            args: {
                search: {},
                sort: {},
                page: 1,
                perPage: 20
            }
        }

        this.handleSort = this.handleSort.bind(this)
        this.handleClearFilters = this.handleClearFilters.bind(this)
        this.handleOnDelete = this.handleOnDelete.bind(this)
    }

    componentDidMount() {
        this.queryAPI()
    }

    initialize() {
        // checkboxes
        this.setState({
            checkboxes: this.createState(this.state.api.pager.perPage),
            _blink: {id: [], action: false}
        })
    }

    queryAPI() {
        _get(this.props.db, this.state.args).then(res => {
            this.setState({api: res.data}, () => {
                this.creatPagination(res.data.pager)
                this.props.hideComponent("refreshList")
                this.initialize()
            })
        })
    }

    doQueryAPI() {
        const time = 1000;
        setTimeout(() => {
            if (this.state._last_action_time + time <= Date.now()) {
                this.queryAPI()
            }
        }, time);
    }

    handleCheckbox(e) {
        let checkboxes = this.state.checkboxes;
        checkboxes[e] = !checkboxes[e]

        this.setState({checkboxes: checkboxes}, () => {
            (this.state.checkboxes.every((val, i, arr) => val === arr[0])) ?
                this.setState({checkbox_all: true}) : this.setState({checkbox_all: false})
        })

        this.handleDeleteMultiple()
    }

    isTrue(element, index, array) {
        return element;
    }

    handleDeleteMultiple() {
        if (this.state.checkboxes.some(this.isTrue)) {
            this.setState({delete_multiple: true})
        } else {
            this.setState({delete_multiple: false})
        }
    }

    createState(count) {
        const arr = []
        for (let i = 0; i < count; i++) {
            arr.push(false)
        }

        return arr;
    }

    handleAllCheckbox() {
        this.setState(prevState => ({
            checkbox_all: !prevState.checkbox_all
        }))

        let checkboxes = this.state.checkboxes
        for (let i = 0; i < this.state.checkboxes.length; i++) {
            checkboxes[i] = !this.state.checkbox_all;
        }
        this.setState({
            checkboxes: checkboxes
        })
        this.handleDeleteMultiple()
    }

    handleSearchField(i, e) {
        const name = e.target.name
        const value = (e.target.value === '') ? '' : e.target.value

        const newData = {...this.state.args}
        newData.search[name] = value
        newData.page = 1

        this.setState({args: newData}, () => (
            this.doQueryAPI()
        ))
    }

    handleSearchFieldSubmit(i, e) {
        this.setState({_last_action_time: Date.now()}, () => {
            this.doQueryAPI();
        })
    }

    creatPagination(data) {
        let pagination = [];

        for (let i = 0; i <= data.pageCount + 1; i++) {
            let label = i;
            let value = i;
            let className = " page-item ";
            let current = false;

            if (i === 0) {
                label = 'Previous'
                value = data.currentPage - 1
            }

            if (i === data.pageCount + 1) {
                label = 'Next'
                value = data.currentPage + 1
            }

            if (i === 0 && data.previous === null) {
                className += " disabled "
            }

            if (i === data.pageCount + 1 && data.next === null) {
                className += " disabled "
            }

            if (i === data.currentPage) {
                className += "  "
                current = true
            }

            if (i - 3 < 0 || i + 3 > data.pageCount || (i - 2 <= data.currentPage && i + 2 >= data.currentPage)) {
                pagination[i] = {
                    label: label,
                    value: value,
                    status: className,
                    current: current
                }
            } else {
                pagination[i] = "..."
            }
        }

        const arr = this.removeConsecutiveDuplicates(pagination)


        this.setState({
            pagination: arr,
            itemsPerPage: this.state.api.perPage
        })
    }

    removeConsecutiveDuplicates(input) {
        let arr = [input[0]]

        for (let i = 1; i < input.length; i++) {
            let x = arr.length - 1;
            if (input[i] !== arr[x]) {
                arr.push(input[i])
            }
        }

        return arr
    }

    handlePaginationTypeIn(event) {

        const page = (event.target.value > this.state.api.pager.pageCount) ? this.state.api.pager.pageCount : event.target.value

        let newData = this.state.args;
        newData.page = page;
        this.setState({args: newData}, () => {
            this.doQueryAPI();
        })
    }

    handlePagination(event) {

        let newArgs = this.state.args;
        newArgs.page = event.target.value;
        this.setState({args: newArgs}, () => {
            this.queryAPI();
        })
    }

    handleSort(i, e) {
        const name = this.state.api.fields[i].name

        let newData = this.state.args
        const newVal = (this.state.args.sort.name === name && this.state.args.sort.value === 'ASC') ? 'DESC' : 'ASC'
        newData.sort = {name: name, value: newVal}

        this.setState({args: newData}, () => {

            this.doQueryAPI();
        })
    }

    blinkOnDelete(timer, i) {
        setTimeout(() => {
            let newData = this.state._blink;
            newData.action = !this.state._blink.action;
            this.setState({_blink: newData});
        }, timer * i);
    }

    handleOnDelete(value) {
        let newData = this.state._blink;
        newData.id = value;
        this.setState({
            _blink: newData
        })

        this.handleAllCheckbox()

        let timer = 300;
        const numberOfBlinks = 6;

        for (let i = 0; i < numberOfBlinks; i++) {
            this.blinkOnDelete(timer, i);
        }


        setTimeout(() => {
            this.queryAPI()
        }, timer * numberOfBlinks)
    }

    handlePerPage(event) {
        let newData = this.state.args;
        newData.perPage = event.target.value
        newData.page = 1;
        this.setState({args: newData}, () => {
            this.queryAPI()
        })
    }

    handleClearFilters() {
        let newData = {...this.state.args}

        Object.keys(newData.search).map(function (key, index) {
            newData.search[key] = "";
        });

        Object.keys(newData.sort).map(function (key, index) {
            newData.sort[key] = "";
        });

        this.setState({args: newData}, () => {
            this.doQueryAPI()
        })
    }

    checkFilters() {


        let result = null;
        let newData = {...this.state.args}

        Object.keys(newData.search).map(function (key, index) {
            result = (newData.search[key] !== "") & true
        });

        Object.keys(newData.sort).map(function (key, index) {
            result = (newData.sort[key] !== "") & true
        });

        return result
    }

    render() {

        const exportCSV = exportCsvPath(this.props.db);
        return (
            <Fragment>
                {(this.state.api) ?
                    <div className="row">
                        <div className="col-lg-12 top-responsive">
                            <div className="card">
                                <div className="card-body">
                                    <div className="inner-custom-pagination d-flex col">
                                        <div className="d-inline">
                                            <div className="btn-group  mb-3 me-2">
                                                <Button api={this.state.api}
                                                        outline
                                                        color="primary"
                                                        onClick={() => this.props.hideComponent({
                                                            component: 'showAdd',
                                                            api: this.state.api
                                                        })}><FontAwesomeIcon icon={faPlus}/> Add Data </Button>
                                            </div>
                                            {this.state.delete_multiple &&
                                            <div className="btn-group  mb-3">
                                                <ModalDelete buttonLabel="Delete Selected"
                                                             buttonClass="waves-effect waves-light" color="danger"
                                                             className="modal-xl modal-dialog-scrollable"
                                                             handleOnDelete={this.handleOnDelete}
                                                             items={this.state.api.list}
                                                             selected={this.state.checkboxes}
                                                             db={this.props.db}/>
                                            </div>}

                                            <div className="btn-group  mb-3">
                                                <Button outline
                                                        color="secondary"
                                                        db={this.props.db}
                                                        returnurl='showList'
                                                        onClick={() => this.props.hideComponent({
                                                            component: 'showImport',
                                                            api: this.state.api
                                                        })}><FontAwesomeIcon icon={faFileImport}/> Import File </Button>
                                            </div>
                                        </div>
                                        <div className="text-md-right ms-auto">
                                            <div className="btn-group  mb-3 me-2">
                                                {(this.checkFilters()) ?
                                                    <Button outline
                                                            color="secondary"
                                                            type="button"
                                                            className="waves-effect waves-light me-2"
                                                            onClick={this.handleClearFilters}>
                                                        <FontAwesomeIcon icon={faWindowClose}/> Clear Filters
                                                    </Button> : null
                                                }
                                                <Link to={{pathname: exportCSV}}
                                                      target="_blank"
                                                      className="btn btn-outline-secondary waves-effect waves-light">
                                                    <FontAwesomeIcon icon={faFileCsv}/> Export CSV
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-hover table-striped table-hover">
                                            <thead className="table-light">
                                            <tr>
                                                <th className="selection-cell-header"
                                                    data-row-selection="true">&nbsp;</th>
                                                {(this.state.api.fields && this.state.args) ? this.state.api.fields.map((field, i) => {
                                                    return (
                                                        <th scope="col" key={i}>
                                                            <label>{field.name}</label>
                                                            <Button outline
                                                                    color="link"
                                                                    onClick={this.handleSort.bind(this, i)}>

                                                                {(this.state.args.sort.name === field.name && this.state.args.sort.value === 'ASC') &&
                                                                <FontAwesomeIcon icon={faSortAmountUp}/>
                                                                }

                                                                {(this.state.args.sort.name === field.name && this.state.args.sort.value === 'DESC') &&
                                                                <FontAwesomeIcon icon={faSortAmountDown}/>
                                                                }

                                                                {(!this.state.args.sort[i]) &&
                                                                <FontAwesomeIcon icon={faSort}/>
                                                                }

                                                            </Button>
                                                        </th>
                                                    )
                                                }) : null}
                                                <th>Actions</th>
                                            </tr>
                                            <tr>
                                                <th className="selection-cell-header" data-row-selection="true">
                                                    <input type="checkbox" checked={this.state.checkbox_all}
                                                           onChange={this.handleAllCheckbox.bind(this)}/>
                                                </th>
                                                {(this.state.api.fields && this.state.args) && this.state.api.fields.map((field, i) => {
                                                    let search_field = "Search " + field.name
                                                    return (
                                                        <th scope="col" key={i}>
                                                            <div className="input-group input-group-sm">
                                                                <input className="form-control"
                                                                       name={field.name}
                                                                       type="search"
                                                                       data-search={field.name}
                                                                       placeholder={search_field}
                                                                       onChange={this.handleSearchField.bind(this, i)}
                                                                       onKeyUp={this.handleSearchFieldSubmit.bind(this, i)}
                                                                       value={this.state.args.search[field.name]}/>
                                                            </div>
                                                        </th>
                                                    )
                                                })}
                                                <th>&nbsp;</th>
                                            </tr>
                                            </thead>
                                            <tbody className="table-hover">
                                            {(this.state.checkboxes) && this.state.api.list.map((item, i) => {
                                                const rowBlink = (this.state._blink.action && this.state._blink.id.includes(i)) ? 'invisible' : ''

                                                return (
                                                    <tr key={i} className={rowBlink}>
                                                        <td className="selection-cell">
                                                            <input type="checkbox" checked={this.state.checkboxes[i]}
                                                                   onChange={this.handleCheckbox.bind(this, i)}/>
                                                        </td>
                                                        {Object.values(item).map((field, index) => {
                                                            return (
                                                                <td key={index}>
                                                                    {(this.state.api.fields[index].type === 'image' && field !== null) &&
                                                                    <img src={imgPath(field)} alt=" "
                                                                         className="datatable_thumb list"/>
                                                                    }
                                                                    {field}
                                                                </td>
                                                            )
                                                        })}
                                                        <td>
                                                            <div className="btn-group mb-2 ms-2">
                                                                <Button onClick={() => this.props.hideComponent({
                                                                    component: 'showEdit',
                                                                    db: this.props.db,
                                                                    item: item.id,
                                                                    return: 'showList'
                                                                })}
                                                                        outline
                                                                        type="button"
                                                                        color="primary"
                                                                        className="waves-effect waves-light btn-sm">
                                                                    <FontAwesomeIcon icon={faPencilAlt}/> Edit
                                                                </Button>
                                                            </div>

                                                            <div className="btn-group mb-2 ms-2">
                                                                <ModalDelete buttonLabel="Delete"
                                                                             buttonClass="waves-effect waves-light btn-sm"
                                                                             color="secondary" className="modal-xl"
                                                                             handleOnDelete={this.handleOnDelete}
                                                                             items={this.state.api.list}
                                                                             selected={i}
                                                                             db={this.props.db}/>
                                                            </div>

                                                        </td>
                                                    </tr>
                                                )
                                            })}

                                            {(!this.state.api.list && this.state.api.fields) &&
                                            <tr>
                                                <td colSpan={(this.state.api.fields && true) ? this.state.api.fields.length + 1 : null}>
                                                    No data found
                                                </td>
                                            </tr>
                                            }

                                            </tbody>
                                            <tfoot className="table-light">
                                            <tr>
                                                <th className="selection-cell-header" data-row-selection="true">
                                                    <input type="checkbox" checked={this.state.checkbox_all}
                                                           onChange={this.handleAllCheckbox.bind(this)}/>
                                                </th>
                                                {this.state.api.fields ? this.state.api.fields.map((field, i) => {
                                                    return (
                                                        <th scope="col" key={i}>{field.name}</th>
                                                    )
                                                }) : null}
                                                <th>Actions</th>
                                            </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    <div className="inner-custom-pagination d-flex col mt-2">
                                        {(this.state.api.pager.perPage && this.state.api.perPage) &&
                                        <div className="d-inline">
                                            <select className="form-select"
                                                    defaultValue={this.state.api.pager.perPage}
                                                    onChange={this.handlePerPage}
                                                    name="limit">
                                                {Object.values(this.state.api.perPage).map((item, i) => {
                                                    return (
                                                        <option key={i} value={item}>{item}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        }
                                        <div className="text-md-right ms-auto">
                                            <nav aria-label="Page navigation example">
                                                {(this.state.api.pager.pageCount && this.state.api.pager.pageCount > 1) ?
                                                    <ul className="pagination">
                                                        {Object.values(this.state.pagination).map((item, i) => {
                                                            return (
                                                                (item.label)
                                                                    ?
                                                                    <li key={i} className={item.status}>
                                                                        {item.current === true
                                                                            ?
                                                                            <input className="page-link text-dark"
                                                                                   name="page"
                                                                                   id="pagination_input"
                                                                                   value={this.state.args.page}
                                                                                   onChange={this.handlePaginationTypeIn.bind(this)}/>
                                                                            :
                                                                            <button className="page-link" name="page"
                                                                                    value={item.value}
                                                                                    onClick={this.handlePagination.bind(this)}>{item.label}</button>
                                                                        }

                                                                    </li>
                                                                    :
                                                                    <li key={i} className="page-item">
                                                                        <span className="page-link">...</span>
                                                                    </li>

                                                            )
                                                        })}
                                                    </ul>
                                                    : null
                                                }
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <Loader isLoading={true}/>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}

export default List;